import { combineReducers } from 'redux';
import {
    SET_NOTE_FIELDS,
    OPEN_NOTE,
    RECEIVE_NOTE_ERROR,
    RECEIVE_PAGE_ERROR,
    CLOSE_NOTE,
} from '../actions/note';
import { switcher } from './utils';

export const initialData = {
    id: null,
    color: 'red',
    note_text: '',
    is_question: false,
    selection_text: '',
    tags: '',
    answered: false,
};

export const data = switcher(initialData, {
    [OPEN_NOTE](state, action) {
        if (action.payload) return { ...action.payload };
        return { ...initialData };
    },
    [CLOSE_NOTE](state, action) {
        return { ...initialData };
    },
    [SET_NOTE_FIELDS](state, action) {
        return {
            ...state,
            ...action.payload,
        };
    },
});

export const error = switcher(null, {
    [OPEN_NOTE](state, action) {
        return null;
    },
    [CLOSE_NOTE](state, action) {
        return null;
    },
    [RECEIVE_NOTE_ERROR](state, action) {
        return action.payload;
    },
});

export const pageError = switcher(null, {
    [OPEN_NOTE](state, action) {
        return null;
    },
    [CLOSE_NOTE](state, action) {
        return null;
    },
    [RECEIVE_PAGE_ERROR](state, action) {
        return action.payload;
    },
});

export default combineReducers({
    data,
    error,
    pageError,
});



// WEBPACK FOOTER //
// ./src/reducers/current_note.js